import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilterFunnelIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="#606060" d="M9.168 14.067a.8.8 0 0 1-.242.691.83.83 0 0 1-1.175 0l-3.342-3.341a.83.83 0 0 1-.241-.692V6.458L.176 1.35A.833.833 0 0 1 .318.183.87.87 0 0 1 .834 0h11.667c.183 0 .358.067.517.183a.833.833 0 0 1 .141 1.167L9.168 6.458zm-6.634-12.4 3.3 4.216v4.6l1.667 1.667V5.875l3.3-4.208z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgFilterFunnelIcon;